<template>
 <div class="com-bottom side-panel top mapBg osy" style="left:25%;">
    <div class="side-panel-bg p-20 mb-20">
      <div class="monitoringbg">
        <div class="monitoringiconvideo fc jc ac">
          <div class="monitoringicontitle">视频</div>
          <div class="monitoringiconCont"><span class="monitoringicontxt">{{dcInfo.video_alarm}}</span>&nbsp;告警</div>
        </div>
        <div class="monitoringicongongdian fc jc ac">
          <div class="monitoringicontitle">供电</div>
          <div class="monitoringiconCont">
            配电柜: <span class="monitoringicontxt c-icon2">{{dcInfo.power_supply_alarm}}</span>&nbsp;告警&nbsp;
            UPS: <span class="monitoringicontxt c-icon2">{{dcInfo.ups_alarm}}</span>&nbsp;告警
          </div>
        </div>
        <div class="monitoringiconanfang fc jc ac">
          <div class="monitoringicontitle">安防</div>
          <div class="monitoringiconCont">
            烟雾:<span class="monitoringicontxt c-icon3">{{dcInfo.lock_alarm}}</span>&nbsp;告警&nbsp;
            水浸:<span class="monitoringicontxt c-icon3">{{dcInfo.water_immersion}}</span>&nbsp;告警
          </div>
        </div>

        <div class="monitoringiconhuanjing fc jc ac">
          <div class="monitoringicontitle">环境</div>
          <div class="monitoringiconCont">
            湿度:<span class="monitoringicontxt c-icon4">{{dcInfo.humidity_alarm}}</span>&nbsp;告警&nbsp;
            温度:<span class="monitoringicontxt c-icon4">{{dcInfo.temperature_alarm}}</span>&nbsp;告警
          </div>
        </div>
        <div class="monitoringiconshebei fc jc ac">
          <div class="monitoringicontitle">设备</div>
          <div class="monitoringiconCont">
            <span class="monitoringicontxt c-icon5">{{dcInfo.device_alarm}}</span>&nbsp;下线&nbsp;
            <span class="monitoringicontxt c-icon5">{{dcInfo.device_offline}}</span>&nbsp;告警
          </div>
        </div>
      </div>
    </div>
    <div class="monitor-ai-ops-block">
      <div class="monitor-title">
        <h3>智能运维</h3>
      </div>
      <div class="monitorcentCon">
          <div class="monitorcentConLft">
            <div class="f-12 tc">异常监测</div>
            <div class="monitorcentConLftTxt">
              <div class="monitorcentConbg fc jc ac">IP为10.10.1.16的ZooKeeper服务无法对外提供服务</div>
              <div class="monitorcentConbg fc jc ac">收到磁盘分区inode资源不足的告警</div>
              <div class="monitorcentConbg fc jc ac">主机网口状态异常</div>
            </div>

          </div>
          <div class="monitorcentConRt">
            <h5>故障定位与运维操作</h5>
            <div style="width:590px;">
              <img  style="width:590px;" src="/imgs/monitorCenterChat.png">
            </div>
          </div>
        </div>
    </div>
 </div>
</template>

<script>

export default {
  name: "VideoDetail",
  components: {
  },
   props: {
    resData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      dcInfo:{},
      problemCount:{},
      colors: ['#A9FF99', '#DF9BFF', '#FFF5C3'],// 颜色列表
    };
  },
  created() {
    //获取视频地址
    // this.request("/file/detail/" + id).then(res => {
    //    this.playerOptions.sources[0].src = res.data.url
    // })
  },
  mounted () {
    this.$nextTick(function () {
      // 初始化dom相关数据
      setTimeout(()=>{
        this.dcInfo = this.resData.centerMonitoring
        this.problemCount = this.resData.problemCount
      },300)
    })
  },
}
</script>


<style scoped>

.monitor-ai-ops-block {
  width: 872px;
  height: 300px;
  background: url("/imgs/monitorCenterbtmborder.png") no-repeat;
  background-size: contain;
  margin: 0 auto;
  position: relative;
  margin-top: 30px;
}

.monitor-title{
  position:absolute;
  width: 642px;
  left: 100px;
  height: 35px;
  top:-30px;
  background: url("/imgs/monitorCenterbtmtitle.png") no-repeat;
  height: 35px;
}
.monitor-title h3{
  font-size: 18px;
  color: #19ECFF;
  letter-spacing: 8.4px;
  text-align: center;
  font-weight: 500;
  line-height: 40px;
}

.side-panel-bg{
  background: rgba(0,0,0,0) !important;
}

.monitoringbg{
  width:852px;
  height:525px;
  background: url("/imgs/monitoringbg.png") no-repeat;
  position: relative;
}
.monitoringiconvideo {
  position: absolute;
  top: -2px;
  left: 190px;
  background: url("/imgs/monitoringiconvideo.png") no-repeat;
  border-radius: 20px;
  /* background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)); */
  background-size: 200px 129px;
  width: 200px;
  height: 129px;
  z-index: 1;
  text-align: center;
}
.monitoringicontitle{
  font-size: 20px;
  color: #33FFF6;
  letter-spacing: 0;
  font-weight: 400;
  margin-top: 22px;
  font-weight: 500;
}
.monitoringiconCont{
  font-size: 10px;
  color: #FFFFFF;
  letter-spacing: 0;
  line-height: 25px;
  font-weight: 600;
  margin-top: 5px;
}
.monitoringicontxt{
  /* font-family: Consolas, sans-serif; */
  font-size: 24px;
  color: #FF8D8D;
  letter-spacing: 0;
  line-height: 25px;
  font-weight: bold;
}

.monitoringiconanfang{
  position: absolute;
  top: 129px;
  left: 43px;
  background: url("/imgs/monitoringiconanfang.png") no-repeat;
  border-radius: 20px;
  background-size: 245px 129px;
  width: 245px;
  height: 129px;
  z-index: 1;
  text-align: center;

}

.monitoringicongongdian {
  position: absolute;
  top: -26px;
  right: 115px;
  border-radius: 20px;
  background:  url("/imgs/monitoringicongongdian.png") no-repeat ;
  background-size: 273px 134px;
  width: 273px;
  height: 134px;
  z-index: 1;
  text-align: center;
}

.monitoringiconhuanjing{
  position: absolute;
  top: 129px;
  right: 0px;
  background: url("/imgs/monitoringiconhuanjing.png") no-repeat;
  border-radius: 20px;
  background-size: 256px 144px;
  width: 256px;
  height: 144px;
  z-index: 1;
  text-align: center;
}

.monitoringiconshebei{
  position: absolute;
  top:237px;
  right:273px;
  background: url("/imgs/monitoringiconshebei.png") no-repeat;
  border-radius: 20px;
  background-size: 235px 134px;
  width: 235px;
  height: 134px;
  z-index: 1;
  text-align: center;
}
.c-icon2{
  color: #62FFB9;
}
.c-icon3{
  color: #FFB6F7;
}
.c-icon4{
  color: #FFF99C;
}
.c-icon5{
  color: #FFA878;
}

.monitorcentConLft{
  float: left;
  margin: 20px 0 0 20px;
}
.monitorcentConbg{
  padding: 11px 20px;
  width: 156px;
  height: 74px;
  background: rgba(0, 145, 133, 0.12);
  margin-top:10px;
  font-size: 12px;
}
.monitorcentConRt{
  float: left;
  margin: 40px 0 0 50px;
}
</style>
